export const GET_HARDWARE = 'GET_HARDWARE';
export const GET_HARDWARE_SUCCESS = 'GET_HARDWARE_SUCCESS';
export const GET_HARDWARE_ERROR = 'GET_HARDWARE_ERROR';
export const GET_HARDWARE_FOR_TARIFF = 'GET_HARDWARE_FOR_TARIFF';